// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_manager.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateRunnerManagerRequest, CreateRunnerManagerResponse, DeleteRunnerManagerRequest, DeleteRunnerManagerResponse, GetRunnerManagerRequest, GetRunnerManagerResponse, ListAvailableRunnerManagersRequest, ListAvailableRunnerManagersResponse, ListRunnerManagersRequest, ListRunnerManagersResponse, UpdateRunnerManagerRequest, UpdateRunnerManagerResponse } from "./runner_manager_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.RunnerManagerService
 */
export const RunnerManagerService = {
  typeName: "gitpod.v1.RunnerManagerService",
  methods: {
    /**
     * @generated from rpc gitpod.v1.RunnerManagerService.CreateRunnerManager
     */
    createRunnerManager: {
      name: "CreateRunnerManager",
      I: CreateRunnerManagerRequest,
      O: CreateRunnerManagerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerManagerService.GetRunnerManager
     */
    getRunnerManager: {
      name: "GetRunnerManager",
      I: GetRunnerManagerRequest,
      O: GetRunnerManagerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerManagerService.UpdateRunnerManager
     */
    updateRunnerManager: {
      name: "UpdateRunnerManager",
      I: UpdateRunnerManagerRequest,
      O: UpdateRunnerManagerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerManagerService.DeleteRunnerManager
     */
    deleteRunnerManager: {
      name: "DeleteRunnerManager",
      I: DeleteRunnerManagerRequest,
      O: DeleteRunnerManagerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all runner managers with full details. Used by account principals for administration.
     *
     * @generated from rpc gitpod.v1.RunnerManagerService.ListRunnerManagers
     */
    listRunnerManagers: {
      name: "ListRunnerManagers",
      I: ListRunnerManagersRequest,
      O: ListRunnerManagersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists available runner managers with minimal details. Used by users to select managed runners for their organization.
     *
     * @generated from rpc gitpod.v1.RunnerManagerService.ListAvailableRunnerManagers
     */
    listAvailableRunnerManagers: {
      name: "ListAvailableRunnerManagers",
      I: ListAvailableRunnerManagersRequest,
      O: ListAvailableRunnerManagersResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

